"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    format: String,
    max: Date,
    min: Date,
    value: String | Date,
    messages: Object,

    // Events
    change: Function
};